<template>
    <v-container fill-height fluid>
      <v-layout justify-center align-center>
        
        <v-flex xs12>
          <material-card class="card-tabs" color="green">
  
            <v-flex slot="header">
              <v-tabs v-model="tabs" color="transparent" slider-color="white">
                <span class="subheading font-weight-light mr-3" style="align-self: center"></span>
                <v-tab class="mr-3">小程序基础设置</v-tab>
                
                <v-tab class="mr-3">小程序订阅消息配置</v-tab>
              </v-tabs>
            </v-flex>
  
            <v-tabs-items v-model="tabs">
              <v-tab-item >
                <mwx :load="true" />
              </v-tab-item>
             
             
              <v-tab-item >
                <templatewxapp :load="tabs == 1" />
              </v-tab-item>
              
            </v-tabs-items>
  
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </template>
  <script>
  import mwx from './ConfigMwx'
 
 
  import templatewxapp from './ConfigMwxTemplate'
  
  export default {
    components:{
      mwx,templatewxapp
    },
    data() {
      return {
        tabs: 0,
        list: {
          0: false,
          1: false
        }
      };
    },
    mounted(){
    },
    methods: {
      complete(index) {
        this.list[index] = !this.list[index];
      }
    }
  };
  </script>